import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { getDateAndTimeInterval, normalizeDate } from '../../../components/Format';
import ModalHeaderComponent from '../../../components/ModalHeader';

type Props = {
  onClose: () => void;
  onOpenNoteEditModal: () => void;
  start_datetime: string;
  end_datetime: string;
  note: string;
};

export default function NoteModal({
  onClose,
  onOpenNoteEditModal,
  start_datetime,
  end_datetime,
  note,
}: Props) {
  const closeModal = () => {
    onClose();
  };

  return (
    <Modal isOpen={true} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent minW="55rem">
        <ModalHeaderComponent title={'申し送り詳細'} />
        <ModalBody>
          <Flex direction={'column'}>
            <Text fontWeight={'bold'}>日時</Text>
            <Text>{getDateAndTimeInterval(start_datetime, end_datetime)}</Text>
          </Flex>
          <Box mt={5} mb={2} overflowY="auto">
            <Text fontWeight={'bold'}>内容</Text>
          </Box>
          <Text className={note ? 'LessonNotesModal-details' : 'LessonNotesModal-details-readOnly'}>
            {note || '申し送りが入力されていません'}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Flex justifyContent="right">
            <Button colorScheme="teal" mr={3} onClick={() => onOpenNoteEditModal()}>
              編集
            </Button>
            <Button colorScheme="gray" onClick={closeModal}>
              キャンセル
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
